// Barkwoo header (Oat & Mint, barkwoo-o0zk.7), loaded as a module by sections/header.liquid.
//
// 1. Scrolled hairline: .section-header gets .bw-header--scrolled once page content
//    passes under the sticky header (the header's natural top is the bottom of the
//    announcement bar above it). assets/bw-header.css draws the 1px line.
// 2. Menu drawer: a tap on any drawer link closes it, so a same-page link such as
//    /#how doesn't scroll behind an open overlay (barkwoo-d3b.39). Dawn's
//    HeaderDrawer (assets/global.js) keeps the focus trap, Escape and scroll lock.
//
// Both use delegation or a fresh lookup, so they survive the theme editor
// re-rendering the header section.

const SCROLLED = 'bw-header--scrolled';

let ticking = false;

function headerOffset(section) {
  const above = section.previousElementSibling;
  return above ? above.getBoundingClientRect().bottom + window.scrollY : 0;
}

function updateScrolled() {
  ticking = false;
  const section = document.querySelector('.section-header');
  if (!section) return;
  section.classList.toggle(SCROLLED, window.scrollY > headerOffset(section));
}

function onScroll() {
  if (ticking) return;
  ticking = true;
  window.requestAnimationFrame(updateScrolled);
}

window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', onScroll, { passive: true });
document.addEventListener('shopify:section:load', onScroll);
updateScrolled();

document.addEventListener('click', (event) => {
  const link = event.target.closest('#menu-drawer a[href]');
  if (!link) return;
  const drawer = link.closest('header-drawer');
  const details = drawer && drawer.querySelector(':scope > details');
  if (!details || !details.hasAttribute('open') || typeof drawer.closeMenuDrawer !== 'function') return;
  const summary = details.querySelector(':scope > summary');
  drawer.closeMenuDrawer(event, summary);
  summary.setAttribute('aria-expanded', 'false');
});
